<template>
  <slot></slot>
</template>

<script>

import AuthMixins from '@/mixins/AuthMixins';

export default {
	mixins: [AuthMixins],

  mounted() {
		if (this.is_localhost) {
    	console.log('localhost: $config.test_env:',this.$config.test_env);
			console.log('localhost: me:',this.me);
			console.log('localhost: $config.white_label :',this.$config.white_label);
		}
  },

	methods:{

	},
	computed: {
		is_localhost() {
			return window.location.href.includes("2021.escapethecity.org");
		}
	}
}
</script>
